import { MultipleConfigOption } from './types';

type Translate = (key: string, options?: Record<string, unknown>) => string;

// Ação de lote da Saúde no Controle Inteligente: é a única com janela de confirmação, nos dois sentidos.
// As contagens usam o plural do i18next (chaves _one/_other).
export function healthRemoteControlOption(t: Translate): MultipleConfigOption {
  const isDisable = (selected: string): boolean => selected === 'disable';

  return {
    value: 'setRemoteControlHealth',
    name: t('habilitarDesabilitarSaudeNoControle'),
    modal: {
      kind: 'confirmedSelect',
      name: t('saudeNoControle'),
      label: t('saudeNoControle'),
      placeholder: t('selecione'),
      options: [
        { name: t('habilitada'), value: 'enable' },
        { name: t('desabilitada'), value: 'disable' },
      ],
      helpText: t('exibeIndicadorSaudeMaquinasControleInteligente'),
      countLabel: (count) => t('unidadesSelecionadas', { count }),
      confirmTitle: (selected, count) => t(
        isDisable(selected) ? 'desabilitarSaudeNoControleEmUnidades' : 'habilitarSaudeNoControleEmUnidades',
        { count },
      ),
      confirmDescription: (selected) => t(
        isDisable(selected) ? 'descricaoDesabilitarSaudeNoControle' : 'descricaoHabilitarSaudeNoControle',
      ),
      success: (selected, count) => t(
        isDisable(selected) ? 'saudeNoControleDesabilitadaEmUnidades' : 'saudeNoControleHabilitadaEmUnidades',
        { count },
      ),
      error: (selected, count) => t(
        isDisable(selected) ? 'erroDesabilitarSaudeNoControleEmUnidades' : 'erroHabilitarSaudeNoControleEmUnidades',
        { count },
      ),
    },
  };
}

export function defaultMultipleConfigOptions(
  t: Translate,
  supervisorList?: { USER: string; NOME: string; SOBRENOME: string }[],
): MultipleConfigOption[] {
  return [
    {
      value: 'setStatus',
      name: t('definirStatus'),
      modal: {
        kind: 'select',
        name: t('alterarStatusUnidade'),
        label: t('status'),
        placeholder: t('selecionarStatus'),
        options: [
          { name: t('emInstalacao'), value: 'installation' },
          { name: t('emProducao'), value: 'operation' },
        ],
        multiple: false,
      },
    },
    {
      value: 'setResponsible',
      name: t('definirResponsavel'),
      modal: {
        kind: 'select',
        name: t('definirResponsavel'),
        label: t('responsavel'),
        placeholder: t('selecioneResponsavel'),
        options: (supervisorList ?? []).map((item) => ({ value: item.USER, name: `${item.NOME} ${item.SOBRENOME}` })),
        multiple: true,
      },
    },
    {
      value: 'setWeeklyReport',
      name: t('definirRelatorioSemanal'),
      modal: {
        kind: 'select',
        name: t('definirRelatorioSemanal'),
        label: t('relatorioSemanal'),
        placeholder: t('selecionarHabilitacao'),
        options: [
          { name: t('habilitarOpcao'), value: 'enable' },
          { name: t('desabilitarOpcao'), value: 'disable' },
        ],
        multiple: false,
      },
    },
    healthRemoteControlOption(t),
  ];
}
